import { apiClient } from '@/shared/api';
import {
  DryRunRequest,
  DryRunResponse,
  PipelineDetailResponse,
  PipelinesListParams,
  PipelinesListResponse,
  RestartRunRequest,
  RestartRunResponse,
  RunDetailResponse,
  RunsListParams,
  RunsListResponse,
} from './types';

// GET /jobs/pipelines - list pipelines
export const fetchPipelines = async (params?: PipelinesListParams) => {
  const queryParams: Record<string, string | number> = {};
  if (params?.limit !== undefined) queryParams.limit = params.limit;
  if (params?.offset !== undefined) queryParams.offset = params.offset;
  const { data } = await apiClient.get<PipelinesListResponse>('/jobs/pipelines', { params: queryParams });
  return data;
};

// GET /jobs/pipelines/{nameOrId} - get pipeline details
export const fetchPipeline = async (nameOrId: string) => {
  const { data } = await apiClient.get<PipelineDetailResponse>(`/jobs/pipelines/${nameOrId}`);
  return data;
};

// POST /jobs/pipelines/{nameOrId}/dry-run - validate pipeline
export const dryRunPipeline = async (nameOrId: string, payload?: DryRunRequest) => {
  const { data } = await apiClient.post<DryRunResponse>(`/jobs/pipelines/${nameOrId}/dry-run`, payload || {});
  return data;
};

// GET /jobs/runs - list runs history
export const fetchRuns = async (params?: RunsListParams) => {
  const { data } = await apiClient.get<RunsListResponse>('/jobs/runs', { params });
  return data;
};

// GET /jobs/runs/{runId} - get run details
export const fetchRun = async (runId: string) => {
  const { data } = await apiClient.get<RunDetailResponse>(`/jobs/runs/${runId}`);
  return data;
};

// POST /jobs/runs/{runId}/restart - restart a run
export const restartRun = async (runId: string, payload?: RestartRunRequest) => {
  const { data } = await apiClient.post<RestartRunResponse>(
    `/jobs/runs/${runId}/restart`,
    payload || { mode: 'from_start' },
  );
  return data;
};
